import { useBlockProps } from '@wordpress/block-editor';
import { RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { FC } from 'react';

interface EditProps {
  attributes: {
    label?: string;
  };
  setAttributes: (attributes: Record<string, any>) => void;
}

const Edit: FC<EditProps> = ({ attributes: {label}, setAttributes }) => {
  return (
      <button {...useBlockProps()}><i className='fa-solid fa-search'></i></button>
  );
};

export default Edit;
